<template>
	<div class="whitelist-form">
		<form class="form" @submit="submit">
			<div class="form-group mt-4">
				<label>Email</label>
				<input required type="email" class="form-control" v-model="form.email">
			</div>

			<div class="form-group mt-4">
				<label>Email Code</label>
				<input required type="text" class="form-control" v-model="form.code">
			</div>

			<div class="form-group mt-4">
				<label>Solana Wallet Address</label>

				<div class="input-group">
					<input required type="text" class="form-control" v-model="form.wallet_addr">
					<Phantom v-if="!$store.state.wallet_connected" class="btn btn-primary">Connect</Phantom>
				</div>
			</div>

			<div class="text-center">
				<button :disabled="alreadyEntered" class="btn btn-primary mt-4" @submit="submit">Submit</button>
			</div>

		</form>
	</div>
</template>

<script>
import Whitelist from "@/api/whitelist"
import Phantom from "../wallet/Phantom";

export default {
	name: "WhitelistForm",
	components: {Phantom},
	data() {
		return {
			alreadyEntered: false,
			form: {
				email: "",
				wallet_addr: "",
				code: "",
				ip: "",
			}
		}
	},
	watch: {
		'$store.state.wallet_addr'() {
			this.form.wallet_addr = this.$store.state.wallet_addr
		}
	},
	methods: {
		submit(e) {
			e.preventDefault()

			Whitelist.create(this.form).then(resp => {
				console.log(resp.data);
				this.$toastr.s("Whitelist Entered");
				this.$router.push("/events/whitelist/success");
			}).catch(err => {
				console.log(err);
				this.alreadyEntered = true;
				this.$toastr.e("Already entered");
			})
		},
		checkWallet() {
			Whitelist.checkWallet(this.$store.state.wallet_addr).then(resp => {
				console.log(resp.data);
			}).catch(err => {
				console.log(err);
				this.alreadyEntered = true;
				this.$toastr.e("Already entered");
			})
		},
		checkCode() {
			Whitelist.checkCode(this.form.code).then(resp => {
				console.log(resp.data);
			}).catch(err => {
				console.log(err);
				this.alreadyEntered = true;
				this.$toastr.e("Already entered");
			})
		},
	},
	mounted() {
		if (this.$route.query.whitelistCode)
			this.form.code = this.$route.query.whitelistCode;

		this.form.wallet_addr = this.$store.state.wallet_addr;
		if (this.form.wallet_addr !== '')
			this.checkWallet()
	}
}
</script>

<style scoped>
.form-control:focus:active, .form-control:focus, .form-control:active {
	background: transparent;
	border-bottom: 1px solid #0a9fb9;
	box-shadow: none;
	color: #0a9fb9;
}

.form-control {
	color: black;
	border-bottom: 1px solid black;
}

</style>